import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import useCompetitionOperation from "../../useCompetitionOperation"

export default function WildCardControls({ eventId, competitionId, userId, refreshKey, busy, onPending, onConfirmed }) {
  const [loaded, setLoaded] = useState(null)
  const [reload, setReload] = useState(0)
  const manager = useCompetitionOperation({ id: eventId, userId, storageScope: "wild-cards:" + competitionId,
    onConfirmed: result => { setLoaded(null); setReload(value => value + 1); onConfirmed(result) } })
  useEffect(() => { onPending(manager.pending) }, [manager.pending, onPending])
  useEffect(() => {
    let active = true, loading = false
    const load = async () => {
      if (loading) return
      loading = true
      try {
        const response = await get('/admin/events/' + eventId + '/competition-directory', { timeout: 15000 })
        const competition = response?.data?.competitions?.find(item => item._id === competitionId)
        if (!competition || ['reserveWC', 'releaseWC'].some(action => typeof competition.permissions?.[action]?.allowed !== 'boolean')) throw new Error('Unavailable')
        if (active) setLoaded({ eventId, competitionId, competition })
      } catch { if (active) setLoaded({ eventId, competitionId, error: true }) }
      finally { loading = false }
    }
    load()
    const timer = setInterval(load, 30000)
    window.addEventListener('focus', load)
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', load) }
  }, [eventId, competitionId, refreshKey, reload])
  const current = loaded?.eventId === eventId && loaded?.competitionId === competitionId ? loaded : null
  return <div className="entries-wc-actions">
    <div className="d-flex flex-wrap">
      {[["reserveWC", "Reserve WC +", "wildCards-plus"], ["releaseWC", "Release WC −", "wildCards-minus"]].map(([key, label, action]) => {
        const permission = current?.competition?.permissions[key]
        const reason = manager.pending ? 'Waiting for the confirmed WC result.' : busy ? 'Another entry operation is in progress.'
          : !userId ? 'Administrator access is not available.'
            : current?.error ? 'WC availability could not be checked. Retry below.'
              : !permission ? 'Checking WC availability…' : !permission.allowed ? permission.reason || 'WC reservations are currently unavailable.' : ''
        const descriptionId = `wc-${competitionId}-${key}`
        return <span key={key} title={reason || undefined} tabIndex={reason ? 0 : undefined} aria-describedby={reason ? descriptionId : undefined}>
          <Button color="light" disabled={Boolean(reason)} aria-describedby={reason ? descriptionId : undefined}
            style={reason ? { pointerEvents: 'none' } : undefined}
            onClick={() => manager.run(current.competition, action)}>{label}</Button>
          {reason && <span id={descriptionId} className="sr-only">{reason}</span>}
        </span>
      })}
    </div>
    {current?.error && <div role="alert" className="text-danger">Could not check WC availability.
      <Button color="link" onClick={() => { setLoaded(null); setReload(value => value + 1) }}>Retry WC availability</Button>
    </div>}
    {manager.status && <div role={manager.status === 'error' ? 'alert' : 'status'} className={'mt-2 text-' + (manager.status === 'error' ? 'danger' : manager.status === 'saved' ? 'success' : 'muted')}>
      {manager.status === 'saved' ? `${manager.action === 'wildCards-plus' ? 'WC place reserved' : 'Unused WC reservation released'}. Reserved WC total: ${manager.wildCards}.`
        : manager.status === 'error' ? manager.message : manager.status === 'unknown'
          ? manager.message || 'The WC result has not been confirmed. Check the saved result before trying again.' : 'Updating WC reservations…'}
      {manager.status === 'unknown' && <Button color="link" onClick={manager.recover}>Check WC result</Button>}
    </div>}
  </div>
}
